import { render, staticRenderFns } from "./i-button.vue?vue&type=template&id=0c69e656&"
import script from "./i-button.vue?vue&type=script&lang=js&"
export * from "./i-button.vue?vue&type=script&lang=js&"
import style0 from "./i-button.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports